"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adjust = exports.update = exports.get = exports.doLoad = exports.getIsLoaded = void 0;
var imports_1 = require("@lib/imports");
var mathUtils_sidecar_1 = require("@lib/mathUtils-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var voyageJsonServerInterface_sidecar_1 = require("@voyage/saver/voyageJsonServerInterface-sidecar");
var voyageBodies_sidecar_1 = require("@voyage/entities/voyageBodies-sidecar");
var voyageBodiesData_sidecar_1 = require("@voyage/entities/voyageBodiesData-sidecar");
var voyageGameManager_sidecar_1 = require("@voyage/game-status/voyageGameManager-sidecar");
var _isDirty = false;
var _saveDelay = 0;
var _isLoaded = false;
var _filename = '_hair_adjust';
var _dir = 'voyage-data';
function trySave() {
    if (_isDirty) {
        var dt = common_sidecar_1.common.getUpdateDelta();
        _saveDelay += dt;
        if (_saveDelay > 1) {
            doSave();
            _isDirty = false;
        }
    }
}
function setDirty() {
    _isDirty = true;
    _saveDelay = 0;
}
function getIsLoaded() {
    return _isLoaded;
}
exports.getIsLoaded = getIsLoaded;
function doSave() {
    var hairs = [];
    imports_1.l.forEach(voyageBodiesData_sidecar_1.voyageBodiesData.hairs, function (c) {
        hairs.push(c.adj);
    });
    var d = { hairs: hairs };
    voyageJsonServerInterface_sidecar_1.voyageJsonServerInterface.save(_filename, d, _dir);
}
function doLoad() {
    return; // disable
    _isLoaded = false;
    voyageJsonServerInterface_sidecar_1.voyageJsonServerInterface.loadAsync(_filename, _dir).then(function (d) {
        var hairs = d.hairs;
        imports_1.l.forEach(voyageBodiesData_sidecar_1.voyageBodiesData.hairs, function (c, cIdx) {
            if (hairs[cIdx]) {
                c.adj = hairs[cIdx];
            }
        });
        // console.log('loaded data')
        // console.log(d)
        _isLoaded = true;
    });
}
exports.doLoad = doLoad;
var _obj = null;
function get() {
    //assert.notNil(_obj, 'editor not created')
    if (!_obj) {
        _obj = create();
    }
    return _obj;
}
exports.get = get;
function create() {
    var obj = {
        body: null,
        body2: null,
        bodyIdx: 0,
        headIdx: 0,
        hairIdx: 0,
    };
    return obj;
}
function update() {
    var obj = get();
    if (voyageGameManager_sidecar_1.voyageGameManager.get().mode !== 'body-align') {
        return;
    }
    if (!obj.body || !obj.body2) {
        obj.body = voyageBodies_sidecar_1.voyageBodies.create();
        voyageBodies_sidecar_1.voyageBodies.moveToXY(obj.body, 500, 500, false);
        voyageBodies_sidecar_1.voyageBodies.scale(obj.body, 4);
        // voyageBodies.rotate(obj.body, angleUtil.turn * 0.05)
        obj.body2 = voyageBodies_sidecar_1.voyageBodies.create();
        voyageBodies_sidecar_1.voyageBodies.moveToXY(obj.body2, 800, 500, false);
        // voyageBodies.rotate(obj.body2, angleUtil.turn * 0.01)
        //voyageBodies.scale(obj.body2, 4)
    }
    // Spin testing
    // let ds = common.getUpdateDeltaScaled()
    // let speed = 0.25
    // voyageBodies.rotate(obj.body, obj.body.rotation + angleUtil.turn * ds * speed)
    // voyageBodies.rotate(
    //   obj.body2,
    //   obj.body2.rotation + angleUtil.turn * ds * speed,
    // )
    obj.bodyIdx = mathUtils_sidecar_1.mathUtils.wrapIndex(obj.bodyIdx, voyageBodiesData_sidecar_1.voyageBodiesData.bodies);
    obj.headIdx = mathUtils_sidecar_1.mathUtils.wrapIndex(obj.headIdx, voyageBodiesData_sidecar_1.voyageBodiesData.heads);
    obj.hairIdx = mathUtils_sidecar_1.mathUtils.wrapIndex(obj.hairIdx, voyageBodiesData_sidecar_1.voyageBodiesData.hairs);
    voyageBodies_sidecar_1.voyageBodies.setBody(obj.body, mathUtils_sidecar_1.mathUtils.getIndexWrapped(obj.bodyIdx, voyageBodiesData_sidecar_1.voyageBodiesData.bodies));
    voyageBodies_sidecar_1.voyageBodies.setHead(obj.body, mathUtils_sidecar_1.mathUtils.getIndexWrapped(obj.headIdx, voyageBodiesData_sidecar_1.voyageBodiesData.heads));
    voyageBodies_sidecar_1.voyageBodies.setHair(obj.body, mathUtils_sidecar_1.mathUtils.getIndexWrapped(obj.hairIdx, voyageBodiesData_sidecar_1.voyageBodiesData.hairs));
    voyageBodies_sidecar_1.voyageBodies.setBody(obj.body2, mathUtils_sidecar_1.mathUtils.getIndexWrapped(obj.bodyIdx, voyageBodiesData_sidecar_1.voyageBodiesData.bodies));
    voyageBodies_sidecar_1.voyageBodies.setHead(obj.body2, mathUtils_sidecar_1.mathUtils.getIndexWrapped(obj.headIdx, voyageBodiesData_sidecar_1.voyageBodiesData.heads));
    voyageBodies_sidecar_1.voyageBodies.setHair(obj.body2, mathUtils_sidecar_1.mathUtils.getIndexWrapped(obj.hairIdx, voyageBodiesData_sidecar_1.voyageBodiesData.hairs));
    trySave();
}
exports.update = update;
function adjust(ox, oy, sx, sy) {
    var obj = get();
    if (obj.body && obj.body2) {
        var adj = obj.body.hair.adj[obj.body.head.idx];
        adj.ox += ox;
        adj.oy += oy;
        adj.sx += sx * 0.01;
        adj.sy += sy * 0.01;
        voyageBodies_sidecar_1.voyageBodies.scale(obj.body, obj.body.scale);
        voyageBodies_sidecar_1.voyageBodies.scale(obj.body2, obj.body2.scale);
        setDirty();
    }
}
exports.adjust = adjust;
